module.exports = __webpack_public_path__ + "static/media/jurnal_bank.b295232f.png";